"use client";

import React, { useState } from "react";
import { TextField } from "../../ui/components/TextField";
import { Button } from "../../ui/components/Button";
import { DiscordLoginButton, GoogleLoginButton } from "react-social-login-buttons";
import { handleProviderSignIn, supabase } from "services/Account/Supabase";

const SignupPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const emailEnabled = false;

  const signUpNewUser = async () => {
    setLoading(true);
    setErrorMessage(null);

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      setLoading(false);
      return;
    }

    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: `${window.location.origin}/welcome`,
      },
    });

    setLoading(false);

    if (error) {
      setErrorMessage(error.message);
    } else {
      alert("Check your email for the confirmation link!");
      window.location.href = "/login";
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-default-background px-6" 
    style={{ backgroundImage: "url('https://i.imgur.com/X0nlfMX.png')" }} >
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-4">Create Account</h2>
        <p className="text-center text-gray-600 mb-6">Get started with your free account.</p>

        {errorMessage && <span className="text-red-500 text-sm">{errorMessage}</span>}

        {emailEnabled && (<div className="flex flex-col gap-4">
          <TextField variant="filled" label="Email" icon="FeatherMail">
            <TextField.Input
              type="email"
              placeholder="Enter your email"
              autoComplete="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </TextField>

          <TextField variant="filled" label="Password" icon="FeatherLock">
            <TextField.Input
              type="password"
              placeholder="Choose a password"
              autoComplete="new-password"
              name="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </TextField>

          <TextField variant="filled" label="Confirm Password" icon="FeatherLock">
            <TextField.Input
              type="password"
              placeholder="Confirm your password"
              autoComplete="new-password"
              name="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </TextField>

          <Button className="h-10 w-full" size="large" disabled={loading} onClick={signUpNewUser}>
            {loading ? "Processing..." : "Sign up"}
          </Button>

          <div className="text-center text-sm mt-2">
            Already have an account? <a href="/login" className="text-blue-600">Log in</a>
          </div>

          <div className="flex items-center my-4">
            <hr className="flex-grow border-gray-300" />
            <span className="mx-2 text-gray-500">or</span>
            <hr className="flex-grow border-gray-300" />
          </div>
        </div>)}



        <GoogleLoginButton onClick={() => handleProviderSignIn("google")} />
        <DiscordLoginButton onClick={() => handleProviderSignIn("discord")} />
      </div>
    </div>
  );
};

export default SignupPage;
